// extracted by mini-css-extract-plugin
export default {"Container":"Guarantee_Container__jwTj0","Logo":"Guarantee_Logo__SPhsW","Content":"Guarantee_Content__+UMCk"};